export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";